import type { ReportSeverityKey } from '@ipfabric/utils/report';
import type { TooltipChildNode } from '../Tooltip/Tooltip';

export const severityDots = {
  '0': <div className='size-full rounded-full bg-status-success' />,
  '10': <div className='size-full rounded-full bg-status-info' />,
  '20': <div className='size-full rounded-full bg-status-warning' />,
  '30': <div className='size-full rounded-full bg-status-error' />,
} satisfies Record<ReportSeverityKey, TooltipChildNode>;
